import { z } from "zod";

import { stringArrayWithoutNulls } from "@/utils/zod";

const materialUsageSchema = z.object({
	usedWidth: z.number(),
	builtInWasteWidth: z.number(),
	trimWidth: z.number(),
	usedLength: z.number(),
});

const baseProductionOptionSchema = z.object({
	materialId: z.string().nullable(),
	materialUsage: materialUsageSchema.nullable(),
	optimal: z.boolean(),
	tileCount: z.number(),
});

export const productionOptionSchema = baseProductionOptionSchema.extend({
	orientations: stringArrayWithoutNulls,
	machineIds: z.array(z.string()),
	machineTypes: z.array(z.string()),
	optimalityLevel: z.number().min(0),
	failureReason: z.string(),
});

const productionDataSchemaPreMachine = z.object({
	failureReason: z.string(),
});

const productionDataSchemaWithMachine = productionDataSchemaPreMachine.extend({
	cycleTime: z.string(),
	waitingTime: z.string().optional().default("00:00:00"),
});

const productionOptionUsedSchemaWithMachine = baseProductionOptionSchema.extend({
	orientation: z.string(),
	machineId: z.string(),
	machineType: z.string(),
	productionData: z.intersection(
		productionDataSchemaWithMachine,
		z.record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null(), z.record(z.string(), z.string())])),
	),
});

const productionOptionUsedSchemaPreMachine = baseProductionOptionSchema.extend({
	orientation: z.string(),
	machineId: z.literal("").transform(() => null),
	machineType: z.string(),
	productionData: productionDataSchemaPreMachine,
});

export const productionOptionUsedSchema = z.union([
	productionOptionUsedSchemaWithMachine,
	productionOptionUsedSchemaPreMachine,
]);

export type ProductionOption = z.infer<typeof productionOptionSchema>;
